export default "__VITE_ASSET__45a88c4d__"